import { render, staticRenderFns } from "./PrintJournalDownPayment.vue?vue&type=template&id=23282f45"
import script from "./PrintJournalDownPayment.vue?vue&type=script&lang=js"
export * from "./PrintJournalDownPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports